import { Component, type ReactNode } from 'react';
import { trackException } from '../lib/telemetry';

interface Props { children: ReactNode; fallback?: ReactNode; }
interface State { err: Error | null; }

export class ErrorBoundary extends Component<Props, State> {
  state: State = { err: null };
  static getDerivedStateFromError(err: Error) { return { err }; }
  componentDidCatch(err: Error) { trackException(err); }
  render() {
    if (this.state.err) {
      return this.props.fallback ?? (
        <div className="p-8">
          <h1 className="text-xl font-semibold">Something went wrong.</h1>
          <button className="underline mt-2" onClick={() => this.setState({ err: null })}>
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
